import * as React from 'react';
import * as style from './style.css';
import { IconButton, IconClose16, UIHeading2, UIText2 } from '@cian/ui-kit';
import { Link } from '../../../Layouts/parts/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ModalHeader = function ModalHeader(_ref) {
  var onClose = _ref.onClose,
    onClick = _ref.onClick,
    title = _ref.title,
    description = _ref.description,
    url = _ref.url;
  return /*#__PURE__*/_jsxs("div", {
    className: style['header'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: style['heading'],
      children: [/*#__PURE__*/_jsx(UIHeading2, {
        children: title
      }), /*#__PURE__*/_jsx(UIText2, {
        children: /*#__PURE__*/_jsx(Link, {
          href: url,
          target: "_blank",
          onClick: onClick,
          children: description
        })
      })]
    }), /*#__PURE__*/_jsx(IconButton, {
      icon: /*#__PURE__*/_jsx(IconClose16, {}),
      onClick: onClose
    })]
  });
};